import {
    GET_USER_SETTING,
    STORE_USER_SETTING,
} from "../../constants/account";

export const getTableSetting = (userId) => ({
    type: GET_USER_SETTING,
    userId
})

export const storeTableSetting = (userTableSetting) => ({
    type: STORE_USER_SETTING,
    userTableSetting
})

